module.exports = __webpack_public_path__ + "media/images/application/template/download-0561e04d8b53725602e6eeae4402534e.png";